import React, {useState} from "react";

import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";

export const DropdownComposer = (Widget) => ((props) => {
  if (!props.items || props.items?.length === 0) {
    return null;
  }

  const [opened, setOpened] = useState(false);

  const newProps = {
    ...props
  }

  const items = (props.items || []);
  newProps.toggleOpen = () => {
    props.toggleOpen?.(!opened)
    setOpened(!opened);
  }
  newProps.close = () => {
    props.onClose && props.onClose();
    setOpened(false);
  }
  newProps.open = () => {
    props.onOpen && props.onOpen();
    setOpened(true);
  }
  newProps.opened = opened;
  newProps.selectedItem = items.find((item: EntityViewModel) => item.id === props.selectedValue);
  newProps.items = items.filter((item: EntityViewModel) => item.id !== props.selectedValue);

  const onChange = (item: EntityViewModel) => {
    setOpened(false);

    if (props.onChange) {
      item.linkModel && (item.linkModel.onClick = props.onChange);
      return props.onChange(item);
    }

    return true;
  }

  return (
    <Widget {...newProps} onChange={(item: EntityViewModel) => onChange(item)}/>
  );
});
